import React from "react";
import StatCard from "../Components/StatCard";
import Layout from "../Layout/Layout";
import contactManager from "../Assets/contactManager.png";
import bubbleGame from "../Assets/bubbleGame.png";
import { SiGithub } from "react-icons/si";
// import { HiStatusOnline } from "react-icons/hi";


const Projects = () => {
  const projectOverview = [
    {
      name: "Python",
      number: 4,
    },
    {
      name: "Django",
      number: 2,
    },
    {
      name: "Php",
      number: 3,
    },
    {
      name: "Codeigniter",
      number: 1,
    },
   
  ];

  return (
    <Layout>
      <div className="sm:ml-[15%] sm:mr-10 mx-6">
        <h1 className="text-center my-2 text-3xl text-white font-semibold">
          Projects Statistics
        </h1>
        <p className="mb-10 mx-[15%] text-gray-200 text-center">
          Project statistics data can be verified by visiting{" "}
          <a
            className="link text-[#64ffda]"
            href="https://github.com/jackwise254"
            target="_blank"
            rel="noopener noreferrer"
          >
            Github Profile
          </a>
        </p>
        {/* for displaying the projects stats */}
        <div className="flex items-center justify-center gap-10 flex-wrap">
          {projectOverview.map((element, index) => {
            return (
              <StatCard
                name={element.name}
                number={element.number}
                key={index}
              />
            );
          })}
        </div>

        {/* for displaying the important projects card */}
        <div className="pb-10">
          <h1 className="text-center mt-16 mb-10 text-3xl text-white font-semibold">
            Project Overview
          </h1>
          <div className="flex flex-col gap-20">
            {/* for project 1 */}
            <div className="flex flex-col sm:flex-row items-center gap-10 text-white">
            <img
                src={contactManager}
                className="sm:w-1/3 border-2 border-[#64ffda] cursor-pointer p-2 transition-all ease-in-out hover:p-0 rounded-md"
                alt="Contact Manager app screenshot"
              />

              {/* right section for project details */}
              <div className="flex flex-col gap-2">
                <h1 className="text-center text-2xl font-semibold mb-4 font-mono">
                  <span className="mr-4 text-xl text-[#64ffda]">01.</span>
                  school management system
                </h1>
                <p className="flex items-center gap-2">
                  <h4 className="font-medium">Project Category :</h4>
                  <p className="text-gray-200">Django</p>
                </p>

                <div>
                  <h4 className="font-medium">Technology Used</h4>
                  <ul className="sm:flex items-center list-disc gap-8 pl-4 flex-wrap text-gray-200">
                    <li>HTML</li>
                    <li>CSS</li>
                    <li>Bootstrap</li>
                    <li>Django</li>
                    <li>Mysql</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-medium">Description</h4>
                  <p className="text-gray-200">
                    It is a full-fledged school management web app, created using
                    the Django. It supports all CRUD features
                    for head teacher, teacher, students and parents
                  </p>
                </div>

                <div>
                  <h4 className="font-medium">Key Features</h4>
                  <ul className="text-gray-200 list-disc pl-4">
                    <li>Simple and easy to use user interface</li>
                    <li>Test account for testing the app</li>
                    <li>Authentication system for signup and login</li>
                    <li>
                      Head teacher can CRUD teahers, students, events, timetable, and parents
                    </li>
                    <li>User can change his password</li>
                    <li>
                      Image uploading support for profile of user and it's
                      contacts
                    </li>
                    <li>Dark and light mode support</li>
                  </ul>
                </div>

                {/* for buttons */}
                <div className="flex items-center gap-4">
                  <button
                    className="hover:text-[#64ffda] transition-all ease-in-out duration-300 tooltip tooltip-accent"
                    data-tip="Repo Link"
                  >
                    <a
                      href="https://github.com/APTech-Kenya/madrassahPython"
                      target={"_blank"}
                      rel="noopener noreferrer"
                    >
                      <SiGithub size={24} />
                    </a>
                  </button>
                  {/* <button
                    className="hover:text-[#64ffda] transition-all ease-in-out duration-300 tooltip tooltip-accent"
                    data-tip="Live Link"
                  >
                    <a
                      href="#"
                      target={"_blank"}
                      rel="noopener noreferrer"
                    >
                      <HiStatusOnline size={24} />
                      
                    </a>
                  </button> */}
                </div>
              </div>
            </div>

            {/* for project 3 */}
            <div className="flex flex-col sm:flex-row items-center gap-10 text-white">
              <img
                src={bubbleGame}
                className="sm:w-1/3 border-2 border-[#64ffda] cursor-pointer p-2 transition-all ease-in-out hover:p-0 rounded-md"
                alt="Contact Manager app screenshot"
              />

              {/* right section for project details */}
              <div className="flex flex-col gap-2">
                <h1 className="text-center text-2xl font-semibold mb-4 font-mono">
                  <span className="mr-4 text-xl text-[#64ffda]">02.</span>
                  Computer Cart
                </h1>
                <p className="flex items-center gap-2">
                  <h4 className="font-medium">Project Category :</h4>
                  <p className="text-gray-200">Python</p>
                </p>

                <div>
                  <h4 className="font-medium">Technology Used</h4>
                  <ul className="flex items-center list-disc gap-8 pl-4 flex-wrap text-gray-200">
                    <li>JavaScript</li>
                    <li>Python</li>
                    <li>Mysql</li>
                    <li>HTML</li>
                    <li>CSS</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-medium">Description</h4>
                  <p className="text-gray-200">
                  A robust web application that allows users to easily manage and track their purchases. Built with Python, JavaScript, and MySQL, the cart supports all CRUD operations, enabling users to create, read, update, and delete items from their cart with ease. In addition to its intuitive interface, the cart also features a comprehensive user management system, complete with login and account creation capabilities.
                  </p>
                </div>

                <div>
                  <h4 className="font-medium">Key Features</h4>
                  <ul className="text-gray-200 list-disc pl-4">
                    <li>Simple and easy to use user interface</li>
                    <li>Built in mail system</li>
                    <li>Authentication module</li>
                    <li>Invoicing module</li>
                    <li>Item tracking module</li>
                  </ul>
                </div>

                {/* for buttons */}
                <div className="flex items-center gap-4">
                  <button
                    className="hover:text-[#64ffda] transition-all ease-in-out duration-300 tooltip tooltip-accent"
                    data-tip="Repo Link"
                  >
                    <a
                      href="https://github.com/jackwise254/computerHUb"
                      target={"_blank"}
                      rel="noopener noreferrer"
                    >
                      <SiGithub size={24} />
                    </a>
                  </button>
                  {/* <button
                    className="hover:text-[#64ffda] transition-all ease-in-out duration-300 tooltip tooltip-accent"
                    data-tip="Live Link"
                  >
                    <a
                      href="#"
                      target={"_blank"}
                      rel="noopener noreferrer"
                    >
                      <HiStatusOnline size={24} />
                    </a>
                  </button> */}
                </div>
              </div>
            </div>
            {/* show more button */}
            <button className="border-2 border-[#1aba95] bg-[#1aba95] px-5 mb-16 sm:mb-0 py-2 rounded-md font-semibold w-fit mx-auto text-white transition-all ease-in-out duration-300 hover:-translate-y-2">
              <a
                className="bg-transparent"
                href="https://github.com/jackwise254"
                target={"_blank"}
                rel="noopener noreferrer"
              >
                And many More
              </a>
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Projects;
